module.exports = __webpack_public_path__ + "static/editor_screen-1c1512e077d3570347208d891792eeb4.png";